import React from 'react'

const CookiesSettings = ({text, className}) => {
  return (
    // eslint-disable-next-line no-script-url
    <a className={className} href="javascript:openAxeptioCookies()">{text}</a>
  )
}

export default CookiesSettings
